import React, { Component } from 'react';
import { Table, DatePicker, Button, Dropdown, Input, message } from 'antd';
import { connect } from 'react-redux';
import _ from 'lodash';
import { logout, getAllUsers, downloadReportDetail, downloadUserData } from '../../user/action/user.actions'
import Header from "../../../layout/DefaultLayout/Header";
import '../../user/component/providerDeshbord.scss'
import { history } from '../../../helpers'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import TableComponent from '../../user/component/dummyTable';
import moment from 'moment';
import SideNav from '../../../layout/DefaultLayout/SideNav';
const items = [
  {
    label: 'Customer',
    key: 'C',
  },
  {
    label: 'Provider',
    key: 'P',
  },
];
export class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersColumns: [
        {
          title: 'Booking Code',
          dataIndex: 'Booking Code',
          key: 'Booking Code',
          sorter: true
        },
        {
          title: 'Booking Description',
          dataIndex: 'Booking Description',
          key: 'Booking Description',
          sorter: true
        },
        {
          title: 'Booking Type',
          dataIndex: 'Booking Type',
          key: 'Booking Type',
          sorter: true
        },
        {
          title: 'Model No',
          dataIndex: 'Model No',
          key: 'Model No',
          sorter: true
        },
        {
          title: 'Product Name',
          dataIndex: 'Product Name',
          key: 'Product Name',
          sorter: true
        },
        {
          title: 'Booking Time',
          dataIndex: 'Booking Time',
          key: 'Booking Time',
          sorter: true
        },
        {
          title: 'Booking Date',
          dataIndex: 'Booking Date',
          key: 'Booking Date',
          sorter: true
        },
        {
          title: 'Bidding Code',
          dataIndex: 'Bidding Code',
          key: 'Bidding Code',
          sorter: true
        },
        {
          title: 'Bidding Date',
          dataIndex: 'Bidding Date',
          key: 'Bidding Date',
          sorter: true
        },
        {
          title: 'Bidding Closing Date',
          dataIndex: 'Bidding Closing Date',
          key: 'Bidding Closing Date',
          sorter: true
        },
        {
          title: 'Bidding Description',
          dataIndex: 'Bidding Description',
          key: 'Bidding Description',
          sorter: true
        },
        {
          title: 'Total Amount',
          dataIndex: 'Total Amount',
          key: 'Total Amount',
          sorter: true
        },
        {
          title: 'Provider Name',
          dataIndex: 'Provider Name',
          key: 'Provider Name',
          sorter: true
        },
        {
          title: 'Provider Email',
          dataIndex: 'Provider Email',
          key: 'Provider Email',
          sorter: true
        },
        {
          title: 'Provider Phone',
          dataIndex: 'Provider Phone',
          key: 'Provider Phone',
          sorter: true
        },
        {
          title: 'Provider Code',
          dataIndex: 'Provider Code',
          key: 'Provider Code',
          sorter: true
        },
        {
          title: 'Customer Name',
          dataIndex: 'Customer Name',
          key: 'Customer Name',
          sorter: true
        },
        {
          title: 'Customer Email',
          dataIndex: 'Customer Email',
          key: 'Customer Email',
          sorter: true
        },
        {
          title: 'Customer Phone',
          dataIndex: 'Customer Phone',
          key: 'Customer Phone',
          sorter: true
        },
        {
          title: 'Customer Code',
          dataIndex: 'Customer Code',
          key: 'Customer Code',
          sorter: true
        },
      ],
      data: [],
      start_date: '',
      end_date: '',
      booking_data: [],
      user_type: 'C',
      sortOrder: null,
      sortedColumn: null
    }
    this.logout = this.logout.bind(this);

  }
  componentDidMount() {
    this.getUsersData();
    this.getBookingData();
  }

  logout(e) {
    const { dispatch } = this.props;
    dispatch(logout())
  }

  getBookingData = () => {
    const { dispatch } = this.props;
    var endDateFormat = new Date()
    var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
    var startDateFormat = new Date()
    startDateFormat.setDate(startDateFormat.getDate() - 30);
    var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
    var data = {
      start_date: startDate,
      end_date: endDate
    }
    dispatch(downloadReportDetail(data)).then((response) => {
      let data = this.initializeDate(response.data)
      this.setState({ booking_data: data, originalData: data })
    })
  }

  getUsersData = () => {
    const { dispatch } = this.props;
    dispatch(getAllUsers()).then((response) => {
      this.setState({ data: response.data })
    })
  }



  initializeDate = (data) => {
    _.map(data, function (record) {
      record['Bidding Date'] = record['Bidding Date'] ? new Date(record['Bidding Date']).toLocaleString() : null
      record['Booking Date'] = record['Booking Date'] ? new Date(record['Booking Date']).toLocaleString() : null
      record['Bidding Closing Date'] = record['Bidding Closing Date'] ? new Date(record['Bidding Closing Date']).toLocaleString() : null
    })
    return data
  }

  downloadReport = () => {
    if(this.state.start_date && this.state.end_date){
      const { dispatch } = this.props;
      var startDateFormat = new Date(this.state.start_date)
      var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
      var endDateFormat = new Date(this.state.end_date)
      var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
      var data = {
        start_date: startDate,
        end_date: endDate
      }
      dispatch(downloadReportDetail(data)).then((response) => {
        let data = this.initializeDate(response.data)
        var dataDownload = data
        var fileName = "Reports"
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(dataDownload);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const dataDetail = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(dataDetail, fileName + fileExtension);
      })
    }else{
      message.error('Please select the start date and end date');
    }
    
  }

  downloadUserDetail = () => {
    const { dispatch } = this.props;
    var data = {
      user_type: this.state.user_type
    }
    dispatch(downloadUserData(data)).then((response) => {
      var dataDownload = response.data
      var fileName = "Reports"
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = '.xlsx';
      const ws = XLSX.utils.json_to_sheet(dataDownload);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const dataDetail = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(dataDetail, fileName + fileExtension);
    })
  }

  filterUserData = () => {
    // if(this.state.start_date && this.state.end_date){
    //   let editData = [...this.state.booking_data]
    //   var startDateFormat = new Date(this.state.start_date)
    //   var endDateFormat = new Date(this.state.end_date)
    //   editData = _.filter(editData, function (o) { return moment(o['Bidding Date']).isBetween(startDateFormat, endDateFormat) });
    //   this.setState({ booking_data: editData });
    // }else{
    //   this.setState({ booking_data: this.state.originalData });
    // }
    if(this.state.start_date && this.state.end_date){
      const { dispatch } = this.props;
      var startDateFormat = new Date(this.state.start_date)
      var startDate = `${startDateFormat.getFullYear()}-${startDateFormat.getMonth() + 1}-${startDateFormat.getDate()}`
      var endDateFormat = new Date(this.state.end_date)
      var endDate = `${endDateFormat.getFullYear()}-${endDateFormat.getMonth() + 1}-${endDateFormat.getDate()}`
      var data = {
        start_date: startDate,
        end_date: endDate
      }
      dispatch(downloadReportDetail(data)).then((response) => {
        let data = this.initializeDate(response.data)
        this.setState({ booking_data: data, originalData: data })
      })
    }else{
      if(!this.state.start_date && !this.state.end_date){
        this.getBookingData()
      }else{
        message.error('Please select the start date and end date');
      }
    }
  }

  handleDateChange = (name, value) => {
    if (name == 'start_date') {
      this.setState({ 'start_date': value });
    } else {
      this.setState({ 'end_date': value });
    }
  }

  // useEffect(() => {
  //   if (sortOrder) {
  //     let editUserData = [...updatedUserData]
  //     if (sortedColumn) {
  //       // editUserData = editUserData.sort((a, b) => {
  //       //   if (sortOrder === 'asc') {
  //       //     return a[sortedColumn] - b[sortedColumn];
  //       //   } else {
  //       //     return b[sortedColumn] - a[sortedColumn];
  //       //   }
  //       // })
  //       editUserData = _.orderBy(editUserData, [sortedColumn], [sortOrder])

  //     }
  //     setUpdatedUserData(editUserData);
  //   }
  // }, [sortOrder])

  handleSort = (column) => {
    let editBookingData = [...this.state.booking_data]
    let order = this.state.sortOrder
    let currentColumn = this.state.sortedColumn
    if (column === currentColumn) {
      // setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
      order = order == 'asc' ? 'desc' : 'asc'
    } else {
      currentColumn = column;
      order = 'asc'
      // setSortedColumn(column);
      // setSortOrder('asc');
    }
    editBookingData = _.orderBy(editBookingData, [currentColumn], [order])
    this.setState({booking_data: editBookingData, sortOrder: order, sortedColumn: currentColumn});
  };


  childRowRenderer = (i) => {
    const columns = [
      {
        title: 'User Name',
        dataIndex: 'userName',
        key: 'userName',
        width: 150,
      },
      {
        title: 'User Code',
        dataIndex: 'userCode',
        key: 'userCode',
        width: 150,
      },
      {
        title: 'Mobile Number',
        dataIndex: 'mobileNumber',
        key: 'mobileNumber',
        width: 150,
      },
      {
        title: 'Bidding Completed',
        dataIndex: 'biddingCompleted',
        key: 'biddingCompleted',
        width: 150,
        render: (catName, record, index) => (
          <div>
            <input style={{ height: '20px', width: '20px' }} type="checkbox" id="myCheckbox" name="myCheckbox" checked={record.biddingCompleted} disabled="disabled" />
          </div>
        ),
      },
      {
        title: 'Profile Verified',
        dataIndex: 'profileVerified',
        key: 'profileVerified',
        render: (catName, record, index) => (
          <div>
            <input style={{ height: '20px', width: '20px' }} type="checkbox" id="myCheckbox" name="myCheckbox" checked={record.profileVerified} disabled="disabled" />
          </div>
        ),
      },
    ];
    const result = i['Partner Details'].map(item => {
      let normalizedString = item.replace(/'/g, '"').replace(/True/g, 'true');
      normalizedString = normalizedString.replace(/'/g, '"').replace(/False/g, 'false');
      let finalData = JSON.parse(normalizedString);
      return {
          'userName': finalData.Name,
          'userCode': finalData.UserCode,
          'mobileNumber': finalData.Phone,
          'biddingCompleted': finalData.UserCode == i['Provider Code'] ? true : false,
          'profileVerified': finalData.IsProfileCompleted
      };
    });
    return <Table
      columns={columns}
      dataSource={result}
      pagination={false}
    />
  };

handleSearch = (value) => {
  let updatedUserData = [...this.state.originalData];
  if (value !== "") {
    updatedUserData = updatedUserData.filter((item) =>
      Object.values(item).some((val) =>
        val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    )
  }
  this.setState({booking_data: updatedUserData})
}

render() {
  const { usersColumns, data, booking_data } = this.state
  return (
    <div>
      <Header></Header>
      <div className="services-background">
        <div className="biddings-container">
          {/* <div className="service-heading-txt">Users</div> */}
          {/* <div style={{ display: 'flex' }}>
              <select style={{
                height: '20px', fontSize: '15px',
                fontFamily: 'nunito-black',
                padding: '0px 26px',
                cursor: 'pointer',
                height: '35px',
                letterSpacing: '1px',
                margin: '20px 10px 0px 0px',
              }} name="Select" id="userType" onChange={(e) => this.setState({ user_type: e.target.value })}>
                <option value="C">Customer</option>
                <option value="P">Provider</option>
              </select>
              <Button className='btn-added-right' onClick={() => { this.downloadUserDetail() }}>
                Download User Data
              </Button>
            </div> */}

          {/* <TableComponent columnsDetails={usersColumns} dataSource={data} /> */}
          <div className="service-heading-txt">Bookings</div>
          <div className="row">
            <div className="col-4">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="Start Date"
                required
                name="start_date"
                value={this.state.start_date}
                onChange={(e) => { this.handleDateChange('start_date', e) }}
              />
            </div>
            <div className="col-4">
              <DatePicker
                className='experience-date-picker-box'
                placeholder="End Date"
                name="end_date"
                value={this.state.end_date}
                onChange={(e) => { this.handleDateChange('end_date', e) }}
              />
            </div>
            <div className="col-4">
              <Button className='btn-added-right' onClick={() => { this.downloadReport() }}>
                Download Report
              </Button>
              <Button className='btn-added-right' onClick={() => { this.filterUserData() }}>
                View Data
              </Button>
            </div>
          </div>
          <Input placeholder="Search" style={{ width: '300px', marginBottom: '20px' }} onChange={(e) => this.handleSearch(e.target.value)} />
          <Table
            columns={usersColumns}
            expandedRowRender={(i) => this.childRowRenderer(i)}
            dataSource={booking_data}
            onChange={(pagination, filters, sorter) => {
              this.handleSort(sorter.field);
            }}
            sortDirections={['ascend', 'descend']}
            sortOrder={this.state.sortOrder}
          />
          {/* <div className='container-tile'>
              Biddings
            </div>
            <div className='container-tile'>
              Customers
            </div>
            <div className='container-tile'>
              Providers
            </div> */}
        </div>
      </div>
    </div >
  );
}
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(mapStateToProps)(AdminLayout);
